import { BsTable, BsSignStop } from 'react-icons/bs';
import { AiOutlineCloudServer } from 'react-icons/ai';
import {CiTempHigh} from 'react-icons/ci';
import {BsDatabase, BsThermometerSun} from 'react-icons/bs';
import { IoLibraryOutline } from 'react-icons/io5';
import {RxInstagramLogo} from 'react-icons/rx';
import { ReactComponent as NLPClassification } from '../assets/Icons/NLPClassification.svg';
import { ReactComponent as FIFO } from '../assets/Icons/FIFO.svg';
import { ReactComponent as DistributedSystems } from '../assets/Icons/DistributedSystems.svg';
import { ReactComponent as MailBulk } from '../assets/Icons/MailBulk.svg';
import { ReactComponent as Play24 } from '../assets/Icons/Play24.svg';
import { ReactComponent as WorldMap } from '../assets/Icons/WorldMap.svg';
import { ReactComponent as Chess } from '../assets/Icons/Chess.svg';



// export const projectEntries = [
//   {
//     title: "FTC Robotics",
//     description: "Implemented a three-wheel odometry tracking system with accuracy of ±1 inch.\nCreated dynamic autonomous program utilizing computer vision, odometry feedback, and pathfinding algorithms to score 90% of all possible autonomous points.\nDesigned overall code base for team.",
//     icon: FaRobot,
//     link: "https://github.com/vcai122/2020-FTC-UltimateGoal",
//   },
//   {
//     title: "Chess Game/Chess AI",
//     description: "Built chess from scratch using Java/Java Swing.\nCreated AI using minimax algorithm with alpha-beta pruning to efficiently look 4 moves ahead with heursitic based on piece value, board position, and number of moves created. Capable of beating novice chess players.",
//     icon: FaChess,
//     link: "https://github.com/vcai122/chess",
//   },
//   {
//     title: "Environmental Maps",
//     description: "Created maps to visualize gridded time series data of 4 different environmental variables (temperature, carbon, land features, aerosol) using Matplotlib and Python.\nCreated React application to display maps in an interactive fashion with animations and sliders.",
//     icon: FaGlobeAmericas,
//     link: "https://github.com/vcai122/environmentalmaps",
//     secondaryLink: "https://vcai122.github.io/environmentalmaps/",
//     secondaryLinkDescription: "See Website",
//     subtitle: "(Charterhacks Hackathon Winning Submission)"
//   },
//   {
//     title: "Play 24 Game",
//     description: "Re-created the classic 24 game from scratch as a web game using React.\nImplemented advanced features like difficulty filter, number appearance frequency, and backtracking auto-solving algorithm.",
//     icon: Play24Icon,
//     link: "https://github.com/vcai122/play24",
//     secondaryLink: "https://vcai122.github.io/play24/",
//     secondaryLinkDescription: "Play Game",
//     reverseGradient: true,
//   },
// ]

// Penn Cloud (C++, gRPC): distributed, fault tolerant Google Apps style cloud platform with mail (POP3 + SMTP) and storage.
// Built scalable Bigtable-like key-value store supporting sequential consistency, primary-based replication, sharding, checkpointing, and crash recovery with configurable number of servers, as database. Handles up to 256 MB files.
// Frontend servers handle HTTP requests, cookies, load balancing, fault tolerance, KV store communication, and caching.

// ArXiv Category Prediction (Python, Sklearn, PyTorch): Multilabel classification of categories of 2 million articles’ abstracts. 
// Embeddings used: Bag of Words, TF-IDF, and BERT. Methods used: KNN, Logistic Regression, LDA, FNN, CNN, LSTM. 
// Pandas for data wrangling/data analysis. Considered subcategories/categories achieving F1 score of 0.5 and 0.73. 

// Distributed Chat Server (C++): replicated servers that use multicast to distribute messages to replicas with UDP sockets. 
// Clients can connect to any server and group. Supports message loss and 4 ordering modes: Unordered, FIFO, Causal, Total.

// Chess Game + Chess AI (Java): Built chess from scratch, implemented complex game logic: Checking, Castling, En Passant… Created AI using minimax algorithm with alpha-beta pruning and efficient heuristic. Capable of looking forward 4 steps.

// Book Recommender (SQL, MongoDB, Express, React): Book/author search engine with per-user recommendations.
// Wrote/optimized complex queries for app features (decreased query time by >90%). Backed by MySQL database in BCNF. 


export const projectEntries = [
  {
    title: "Penn Cloud",
    description: "Distributed, fault tolerant Google Apps style cloud platform with mail (POP3 + SMTP protocol) and storage.",
    icons: [AiOutlineCloudServer, MailBulk, BsTable],
    tools: "(C++, gRPC)",
    bullets: [
      "Built scalable Bigtable-like key-value store supporting sequential consistency, primary-based replication, sharding, checkpointing, and crash recovery with configurable number of servers, as database. Handles up to 256 MB files.",
      "Frontend servers handle HTTP requests, cookies, load balancing, fault tolerance, KV store communication, and caching."
    ],
    iconStyle: {top: "15%"}
  },
  {
    title: "ArXiv Category Prediction",
    description: "Multilabel classification of categories of 2 million articles’ abstracts.",
    icons: [NLPClassification],
    tools: "(Python, Sklearn, PyTorch)",
    bullets: [
      "Embeddings used: Bag of Words, TF-IDF, and BERT. Methods used: KNN, Logistic Regression, LDA, FNN, CNN, LSTM.",
      "Pandas for data wrangling/data analysis. Considered subcategories/categories achieving F1 score of 0.5 and 0.73."
    ],
    iconStyle: {top: "30%"}
  },
  {
    title: "Distributed Chat Server",
    description: "Replicated servers that use multicast to distribute messages to replicas with UDP sockets.",
    icons: [DistributedSystems, FIFO],
    tools: "(C++)",
    bullets: [
      "Clients can connect to any server and group. Supports message loss and 4 ordering modes: Unordered, FIFO, Causal, Total."
    ],
    iconStyle: {top: "30%"}
  },
  {
    title: "Chess Game + Chess AI",
    description: "Built chess from scratch, implemented complex game logic: Checking, Castling, En Passant… Created AI using minimax algorithm with alpha-beta pruning and efficient heuristic. Capable of looking forward 4 steps.",
    icons: [Chess],
    tools: "(Java)"
  },
  {
    title: "Book Recommender",
    description: "Book/author search engine with per-user recommendations.",
    icons: [IoLibraryOutline, BsDatabase],
    tools: "(SQL, MongoDB, Express, React)",
    bullets: [
      "Wrote/optimized complex queries for app features (decreased query time by >90%). Backed by MySQL database in BCNF."
    ],
  },
  {
    title: "Traffic Sign Recognition",
    description: "Trained/compared KNN, Logistic Regression, SVM, MLP, CNN for traffic sign recognition. Accounted for class imbalance. Employed dimensionality reduction techniques such as PCA. Achieved F1 score of 0.99.",
    icons: [BsSignStop],
    tools: "(Python, Sklearn, PyTorch)",
    iconStyle: {paddingTop: "0.5rem", paddingLeft: "0.5rem"}
  },
  {
    title: "Instagram Clone (2 ways)",
    description: "Instagram clone implemented with 2 different stacks, both with all core features: posting, liking, commenting, following, searching, as well as authentication, follower suggestions, sessions, and security features.",
    icons: [RxInstagramLogo],
    tools: "(MongoDB, Express, React, Node / Django)"
  },
  {
    title: "Environmental Maps",
    description: "Created maps to visualize gridded time series data of 4 different environmental variables (temperature, carbon, land features, aerosol). Displayed in interactive fashion with animations and sliders.",
    icons: [WorldMap, BsThermometerSun],
    tools: "(Matplotlib, Python)",
  },
  {
    title: "Play 24 Game",
    description: "Re-created the classic 24 game as a web game using React.",
    icons: [Play24],
    tools: "(React)",
    bullets: [
      "Implemented advanced features like difficulty filter, number appearance frequency, and backtracking auto-solving algorithm."
    ],
  },
]